import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import PremiumPackagesCatalogBlockData from '../../../Models/Content/PremiumPackagesCatalogBlockData';
import PremiumPackagesCatalog from './premiumPackagesCatalog';

export default class PremiumPackagesCatalogBlock extends EpiComponent<PremiumPackagesCatalogBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['premium-packages-catalog-block'];

    return (
      <div className={cssClasses.join(' ')}>
        <div className='premium-packages-catalog-wrapper'>
          <PremiumPackagesCatalog iContent={this.props.data} context={this.getContext()} />
        </div>
      </div>
    );
  }
}
